import { useMutation, useQueryClient } from '@tanstack/react-query';
import mcpUsuariosService from '../services/mcpUsuariosService';
import { mcpUsuariosKeys } from '../queryKeys';

const useEditarMcpUsuario = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, cambios }) => mcpUsuariosService.editar({ headquarter, id, cambios }),
    onSuccess: () => qc.invalidateQueries({ queryKey: mcpUsuariosKeys.all }),
  });
};

export default useEditarMcpUsuario;
